export const AUTH_STORAGE_KEY = 'rid.jwt';
export const REFRESH_STORAGE_KEY = 'rid.refresh';
export const ROUTE_STORAGE_KEY = 'rid.lastRoute';
export const DEFAULT_ORG_STORAGE_KEY = 'rid.defaultOrg';
export const getDefaultOrgStorageKey = (userId: number | string) =>
  `${DEFAULT_ORG_STORAGE_KEY}.${userId}`;
export const SELECTED_ORG_ID_STORAGE_KEY = 'rid.selectedOrgId';
export const METRC_SSO_REDIRECT_STATE_STORAGE_KEY = 'rid.metrcSsoRedirectState';
export const DEFAULT_API_BASE_URL = (
  window.__APP_CONFIG__?.API_BASE_URL ||
  (import.meta.env && import.meta.env.VITE_API_BASE_URL) ||
  'http://localhost:8080'
).replace(/\/+$/, '');
export const PAGE_SIZE_OPTIONS = [10, 25, 50] as const;
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];
export const DEFAULT_LIST_PAGE = 0;
export const DEFAULT_LIST_PAGE_SIZE = DEFAULT_PAGE_SIZE;
export const DEFAULT_LOOKUP_PAGE_SIZE = 500;
export const ORGANIZATION_SEARCH_MIN_CHARACTERS = 1;
export const ORGANIZATION_SEARCH_DEBOUNCE_MS = 500;
export const ORGANIZATION_SEARCH_PAGE_SIZE = 20;
export const PRODUCT_SELECTOR_RESULT_PAGE_SIZE = 8;
export const PRODUCT_SELECTOR_DEBOUNCE_MS = 300;
export const PRODUCT_SELECTOR_MIN_QUERY_LENGTH = 3;
export const PACKAGE_SELECTOR_RESULT_PAGE_SIZE = 8;
export const PACKAGE_SELECTOR_DEBOUNCE_MS = 300;
export const PACKAGE_SELECTOR_MIN_QUERY_LENGTH = 3;
export const FILE_TYPE_STATIC = 0;
export const FILE_TYPE_PRODUCT_IMAGE = 1;
export const FILE_TYPE_BRAND_LOGO = 2;
export const FILE_TYPE_COA = 4;

export const ROUTE_EXCLUDE_PREFIXES = [
  '/login',
  '/signup',
  '/forgot',
  '/reset',
  '/verify/email',
  '/landingpage',
  '/coa_results',
];

export const APP2_SUPPORTED_ROUTE_PREFIXES = [
  '/products',
  '/brands',
  '/organizations',
  '/templates',
  '/users',
  '/profile',
  '/admin',
  '/internal',
  '/packages',
  '/prints',
  '/imports',
  '/facilities',
];

export const PERM_NONE = 0;
export const PERM_READ = 1;
export const PERM_WRITE = 2;
export const PERM_ADMIN = 4;

export const USER_ROLE_OPTIONS = ['Admin', 'Manager', 'Designer', 'Viewer'];

export const MARKET_OPTIONS = [
  'CA', 'CO', 'MI', 'AZ', 'NV', 'OR', 'WA', 'IL', 'NY', 'MA',
  'NJ', 'PA', 'MD', 'VA', 'FL', 'TX', 'OH', 'OK', 'MO', 'MN',
  'WI', 'GA', 'NC', 'SC', 'TN', 'KY', 'LA', 'NM', 'MT', 'ME',
];

export * from './unitsOfMeasure';
